module.exports = __webpack_public_path__ + "img/about_chart.f4c7e57e.png";